module.exports = __webpack_public_path__ + "img/listo-compassion-logo.dbb8fa9d.png";